module.exports = __webpack_public_path__ + "assets/6b979532e752d5f242cd1acf07087a1e.mp3";